var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 27H7.33333C6.44928 27 5.60143 26.6689 4.97631 26.0795C4.35119 25.4901 4 24.6907 4 23.8571V8.14286C4 7.30932 4.35119 6.50992 4.97631 5.92052C5.60143 5.33112 6.44928 5 7.33333 5H30.6667C31.5507 5 32.3986 5.33112 33.0237 5.92052C33.6488 6.50992 34 7.30932 34 8.14286V19.9286",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 8L19 18L34 8",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 27C25 27.7956 25.3161 28.5587 25.8787 29.1213C26.4413 29.6839 27.2044 30 28 30C28.7956 30 29.5587 29.6839 30.1213 29.1213C30.6839 28.5587 31 27.7956 31 27C31 26.2044 30.6839 25.4413 30.1213 24.8787C29.5587 24.3161 28.7956 24 28 24C27.2044 24 26.4413 24.3161 25.8787 24.8787C25.3161 25.4413 25 26.2044 25 27Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31 27.0077V28.0077C31 28.4497 31.0159 28.8737 31.3285 29.1862C31.6411 29.4988 31.8913 29.6744 32.3333 29.6744C32.7754 29.6744 33.1993 29.4988 33.5118 29.1862C33.8244 28.8737 34 28.4497 34 28.0077V27.0077C34.0017 25.7184 33.588 24.4629 32.8203 23.4272C32.0525 22.3914 30.9716 21.6305 29.7376 21.2571C28.5036 20.8837 27.1821 20.9178 25.969 21.3542C24.7558 21.7906 23.7155 22.6062 23.0021 23.6802C22.2888 24.7541 21.9403 26.0292 22.0084 27.3167C22.0764 28.6042 22.5574 29.8355 23.38 30.8282C24.2026 31.821 25.3231 32.5223 26.5755 32.8284C27.8279 33.1345 29.1455 33.0291 30.3333 32.5277",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredEmail);
export default __webpack_public_path__ + "static/media/ic-colored-email.08261d66f702986b9260af3857f32afb.svg";
export { ForwardRef as ReactComponent };